// extracted by mini-css-extract-plugin
module.exports = {"blueCardOuter":"_2o5rq"};